module.exports = __webpack_public_path__ + "img/unlink.0968205c.svg";